<template>
  <div id="navigation">
    <audio ref="dripdrip" :src="$assets.media['drip-drip2.wav']">
      <track kind="captions" />
    </audio>
    <audio ref="dropploop" :src="$assets.media['drop-ploop2.wav']">
      <track kind="captions" />
    </audio>

    <MobileMenuBar @expand="expandMenu" />

    <MenuBar @expand="expandMenu" @goBack="goBack" @goDashboard="goDashboard" @goProfile="goProfile" @logout="logout" />

    <ExpandedMenu
      :class="{ expanded: menuExpanded }"
      @fold="foldMenu"
      @goToLearn="goToLearn"
      @goClientList="goClientList"
      @goProfile="goProfile"
      @logout="logout"
    />
  </div>
</template>

<script>
import ExpandedMenu from '@/components/navigation/ExpandedMenu.vue';
import MenuBar from '@/components/navigation/MenuBar.vue';
import MobileMenuBar from '@/components/navigation/MobileMenuBar.vue';

export default {
  data() {
    return {
      menuExpanded: false,
    };
  },

  methods: {
    expandMenu() {
      this.menuExpanded = true;
      this.$refs.dripdrip.play();
    },
    foldMenu() {
      this.menuExpanded = false;
      this.$refs.dropploop.play();
    },

    goBack() {
      this.redirectPath(this.levelUp);
    },

    goDashboard() {
      this.redirectPath({ name: 'dashboard' });
    },

    goToLearn(learningType) {
      if (this.currentFunction.key === learningType.learning_type_key) {
        return;
      }

      if (learningType.learning_type_status !== 'available') {
        return;
      }

      this.foldMenu();
      this.redirectPath({
        name: learningType.learning_type_path,
        params: { learningTypeId: learningType.id },
      });
    },

    goClientList() {
      if (this.currentFunction.key === 'client-service') {
        return;
      }

      this.foldMenu();
      this.redirectPath({ name: 'clientList' });
    },

    goProfile() {
      if (this.currentFunction.key === 'profile') {
        return;
      }

      this.foldMenu();
      this.redirectPath({ path: '/personal' });
    },

    async logout() {
      await this.$utils.session.logout();
    },

    redirectPath(route) {
      this.$router.push(route).catch((err) => {
        this.$utils.log.debug('-------');
        this.$utils.log.debug('[Redirect Warning]: ');
        this.$utils.log.debug(err.message);
        this.$utils.log.debug('-------');
      });
    },
  },

  computed: {
    levelUp() {
      return this.$store.getters.levelUp;
    },
    currentFunction() {
      return this.$store.getters.currentFunction || {};
    },
  },

  watch: {
    menuExpanded(val) {
      this.$el.ownerDocument.body.classList[val ? 'add' : 'remove']('lock');
    },
  },

  components: {
    MenuBar,
    MobileMenuBar,
    ExpandedMenu,
  },
};
</script>
